import { CreateService, CRUDServiceInterface } from '@/services/service';
import { PostReactionEntity } from '@/entities/post-reaction.entity';

export default class PostReactionService
  extends CreateService<PostReactionEntity>('post-reaction')
  implements CRUDServiceInterface<PostReactionEntity>
{
  async createOne(
    instance: Partial<PostReactionEntity>,
  ): Promise<PostReactionEntity> {
    const { data } = await this.apiBuilder.createOne(instance);
    return data;
  }

  async getOne(id: number): Promise<PostReactionEntity> {
    const { data } = await this.apiBuilder.getOne(id);
    return data;
  }

  async updateOne(
    id: number,
    instance: Partial<PostReactionEntity>,
  ): Promise<PostReactionEntity> {
    const { data } = await this.apiBuilder.updateOne(id, instance);
    return data;
  }

  async getMany(
    commentId: string | number,
    emoticonId: string | number,
  ): Promise<PostReactionEntity[]> {
    this.apiBuilder.reset()
    const [items] = await this.apiBuilder
      .clone()
      .join('staff')
      .filter('issueId', '$eq', String(commentId))
      .filter('emoticonId', '$eq', String(emoticonId))
      .getMany();
    return items;
  }
}
